import { motion } from "framer-motion";
import SectionLabel from "../site/SectionLabel";
import { HOME_SECTIONS } from "@/constants/testIds";

const chapters = [
  {
    n: "01",
    title: "Business first.",
    body: "We understand the business, customer and market before starting the design.",
  },
  {
    n: "02",
    title: "Senior-led thinking.",
    body: "Experienced designers and strategists stay closely involved throughout the project.",
  },
  {
    n: "03",
    title: "One connected system.",
    body: "Brand, digital, packaging and communication work together—not as separate pieces.",
  },
  {
    n: "04",
    title: "Built for growth.",
    body: "We create design systems that can grow with the business across markets, products and channels.",
  },
];

export default function Manifesto() {
  return (
    <section
      data-testid={HOME_SECTIONS.manifesto}
      className="relative bg-ink-950 py-28 lg:py-40"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <SectionLabel number="02">Manifesto</SectionLabel>
        <h2 className="mt-8 max-w-4xl font-display text-5xl leading-[0.98] tracking-tighter text-ivory lg:text-7xl">
          Built around <span className="italic text-gold">business.</span>
        </h2>

        <div className="mt-20 grid grid-cols-1 gap-y-2 divide-y divide-ivory/[0.06] border-y border-ivory/[0.06] md:grid-cols-2 md:divide-x md:divide-y-0">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.76, 0, 0.24, 1] }}
              className="group relative flex flex-col gap-8 p-8 py-12 lg:p-16"
            >
              <div className="flex items-start justify-between">
                <div className="font-display text-6xl italic text-gold lg:text-7xl">{c.n}</div>
                <div className="mt-3 font-sans text-[11px] uppercase tracking-widest text-ivory-dim">
                  Chapter {c.n}
                </div>
              </div>
              <h3 className="font-display text-3xl leading-tight tracking-tight text-ivory lg:text-4xl">
                {c.title}
              </h3>
              <p className="max-w-md font-sans text-base leading-relaxed text-ivory-soft">
                {c.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
